require('./currencyDropdownValueComponent.scss');
// @ vendor
const React = require('react');
// @ vendor
const PropTypes = require('prop-types');

// @ constants
const { CURRENCIES_SYMBOLS } = require('constants/currencies');

class CurrencyDropdownValueComponent extends React.Component {

    render() {
        const { value } = this.props;
        return (
            <div className="Select-value">
                <div className="Select-value-label currency-dropdown-value-component">
                    <span className="currency-dropdown-value-component__currency-text">{value.label}</span> 
                    <span className="currency-dropdown-value-component__currency-symbols">{value.value} ({CURRENCIES_SYMBOLS[value.value]})</span>
                </div>
            </div>
        );
    }
}

CurrencyDropdownValueComponent.propTypes = {
    value: PropTypes.object.isRequired,
};

module.exports = CurrencyDropdownValueComponent;